class BannerCarousel extends HTMLElement {
  constructor() {
    super();

    this.swiperEl = this.querySelector(".banner-carousel-swiper");
    this.swiperSlides = this.swiperEl.querySelectorAll(".swiper-slide");
    this.swiperSlideFirst = this.swiperSlides[0];
    this.swiperNext = this.querySelector('.banner-button-next');
    this.swiperPrev = this.querySelector('.banner-button-prev');
    this.swiperPagination = this.querySelector('.swiper-pagination');
    this.autoplay = this.hasAttribute('data-autoplay');
    this.duration = this.getAttribute('data-duration') || 5000;
  }

  connectedCallback() {
    this.waitForImagesToLoad().then(() => {
      this.initSwiper();
    });
  }

  waitForImagesToLoad() {
    const images = this.querySelectorAll('img');
    const promises = Array.from(images).map((img) => {
      if (img.complete) return Promise.resolve();
      return new Promise((resolve) => {
        img.onload = resolve;
        img.onerror = resolve;
      });
    });
    return Promise.all(promises);
  }

  initSwiper() {
    const options = {
      loop: true,
      centeredSlides: true,
      slidesPerView: 1.3,
      spaceBetween: 20,
      speed: 400,
      // observeParents: true,
      // observeSlideChildren: true,
      navigation: {
        nextEl: this.swiperNext,
        prevEl: this.swiperPrev
      },
      pagination: {
        el: this.swiperPagination,
        clickable: true
      }
    };

    if (this.autoplay) {
      options.autoplay = {
        delay: this.duration
      };
    }

    const swiperInstance = new window.Swiper(this.swiperEl, options);

    // 强制更新以防 Swiper 未识别新尺寸
    requestAnimationFrame(() => {
      swiperInstance.update();
    });

    this.classList.add('swiper-initialized');

    // 视频控制逻辑
    this.pauseAllVideo();
    const videoFirst = this.swiperSlideFirst.querySelector("video-player");
    if (videoFirst) {
      this.handlePlayVideo(videoFirst.getAttribute("data-type"), videoFirst);
    }

    swiperInstance.on("slideChange", (swiper) => {
      const slideActive = swiper.slides[swiper.activeIndex];
      const videosCurrentActive = slideActive.querySelectorAll("video-player");
      this.pauseAllVideo();

      videosCurrentActive.forEach((video) => {
        const type = video.getAttribute("data-type");
        this.handlePlayVideo(type, video);
      });
    });
  }

  pauseAllVideo() {
    const allVideos = this.querySelectorAll("video-player");
    allVideos.forEach((video) => {
      const type = video.getAttribute("data-type");
      this.handlePauseVideo(type, video);
    });
  }

  async handlePauseVideo(type, el) {
    await customElements.whenDefined("video-player");
    if (typeof el.pause !== "function" || typeof el.vimeoPause !== 'function' || typeof el.youtubePause !== 'function') return;

    switch (type) {
      case "youtube":
        el.youtubePause();
        break;
      case "vimeo":
        el.vimeoPause();
        break;
      case "mp4":
        el.pause();
        break;
    }
  }

  async handlePlayVideo(type, el) {
    await customElements.whenDefined("video-player");
    if (typeof el.play !== "function" || typeof el.vimeoPlay !== 'function' || typeof el.youtubePlay !== 'function') return;

    switch (type) {
      case "youtube":
        el.youtubePlay();
        break;
      case "vimeo":
        el.vimeoPlay();
        break;
      case "mp4":
        el.play();
        break;
    }
  }
}

if (!customElements.get("banner-carousel")) {
  customElements.define("banner-carousel", BannerCarousel);
}
